import React from "react";
import {Toaster} from "react-hot-toast";
import {useContext} from "react";
import {ThemeContext} from "../../contexts/ThemeContext";

interface NotificationProviderProps {
  children: React.ReactNode;
}

const NotificationProvider: React.FC<NotificationProviderProps> = ({children}) => {
  const {theme} = useContext(ThemeContext);

  return (
    <>
      {children}
      <Toaster
        position="top-right"
        reverseOrder={false}
        gutter={8}
        toastOptions={{
          duration: 4000,
          style: {
            background: theme === "dark" ? "#27293d" : "#fff",
            color: theme === "dark" ? "#fff" : "#1e1e2f",
            border: `1px solid ${theme === "dark" ? "#2b3553" : "#e3e3e3"}`,
            borderRadius: "4px",
            fontSize: "14px",
            padding: "12px 16px"
          },
          success: {
            iconTheme: {
              primary: "#00f2c3",
              secondary: theme === "dark" ? "#27293d" : "#fff"
            }
          },
          error: {
            iconTheme: {
              primary: "#fd5d93",
              secondary: theme === "dark" ? "#27293d" : "#fff"
            }
          }
        }}
      />
    </>
  );
};

export default NotificationProvider;
